import { ArrowsLeftRightIcon, KanbanIcon } from '@phosphor-icons/react'
import type { NodeProps } from '@xyflow/react'
import { useListCopy } from 'app/hooks/useListCopy'
import type { AddToPipelineFlowNode } from 'app/types/workflows'
import { NodeShell } from './NodeShell'

/** Adds the contact to a pipeline, or moves them to a stage within one. */
export function AddToPipelineNode({ data, selected }: NodeProps<AddToPipelineFlowNode>) {
  const copy = useListCopy()
  const isMove = data.operation === `move`
  const name = data.pipelineId ? data.pipelineName || copy.noun : undefined
  const description = !name
    ? copy.noListSelected
    : isMove
      ? data.stage
        ? `Move contact to ${data.stage} · ${name}`
        : `Pick a stage in ${name}`
      : data.stage
        ? `Add contact to ${name} · ${data.stage}`
        : `Add contact to ${name}`
  return (
    <NodeShell
      icon={isMove ? ArrowsLeftRightIcon : KanbanIcon}
      accent="sky"
      kind={isMove ? copy.moveListStage : copy.addToList}
      label={data.label}
      description={description}
      selected={selected}
    />
  )
}
